import React, { useContext } from "react";
import CartContext from "../../context/CartContext";
import { Box, Typography, Divider, Paper } from "@mui/material";

const BillDetails = () => {
  const cartCtx = useContext(CartContext);
  const total = cartCtx.items.reduce(
    (acc, cur) => acc + parseFloat(cur.price) * cur.qty,
    0
  );
  const toPay = cartCtx.items.reduce(
    (acc, cur) =>
      acc + parseFloat(cur.specialprice ? cur.specialprice : cur.price) * cur.qty,
    0
  );
  const discount = total - toPay
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        // mb: 2,
        // mt:2,
      }}
    >

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography sx={{ fontSize: "17px", fontWeight: 500}}>
          Net Total
        </Typography>
        <Typography sx={{ fontSize: "1.1rem", fontWeight: 500 }}>
          ₹ {total.toFixed(2)}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
        <Typography sx={{ fontSize: "17px", fontWeight: 500 }}>
          Discount Total
        </Typography>
        <Typography sx={{ fontSize: "1.1rem", fontWeight: 500 }}>
          ₹ {discount.toFixed(2)}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 1,

        }}
      >
        <Typography
          sx={{ fontSize: "17px", fontWeight: 500 }}
        >
          Sub Total
        </Typography>
        <Typography
          sx={{
            fontSize: "1.125rem",
            fontWeight: "bold",
            color: "#e44d26",
          }}
        >
          ₹ {toPay.toFixed(2)}
        </Typography>
      </Box>
    </Paper>
  );
};

export default BillDetails;
